import React, { useState, useEffect } from 'react';
import { FaSchool, FaFlask, FaBook, FaRunning, FaChalkboardTeacher, FaDesktop, FaPaintBrush, FaMusic, FaBus } from 'react-icons/fa';
import Navbar from './Header';
import Footer from './Footer';

function Facilities() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const oneWordPerLine = {
    wordBreak: isMobile ? 'break-all' : 'normal',
    whiteSpace: isMobile ? 'pre-wrap' : 'normal',
    display: isMobile ? 'inline-block' : 'inline',
  };

  const facilities = [
    { icon: <FaSchool />, title: 'Modern Classrooms', description: 'Spacious, well-lit classrooms equipped with smart boards and ergonomic furniture to enhance learning.' },
    { icon: <FaFlask />, title: 'Science Laboratories', description: 'Advanced labs with modern equipment for conducting experiments in physics, chemistry, and biology.' },
    { icon: <FaBook />, title: 'Library', description: 'A vast collection of books and digital resources to support research and reading for all ages.' },
    { icon: <FaRunning />, title: 'Sports Facilities', description: 'State-of-the-art fields and courts for various sports, promoting physical fitness and teamwork.' },
    { icon: <FaChalkboardTeacher />, title: 'Activity Rooms', description: 'Dedicated spaces for extracurricular activities, fostering creativity and skill development.' },
    { icon: <FaDesktop />, title: 'Computer Lab', description: 'High-tech lab with latest computers and software for coding and digital literacy training.' },
   
  ];

  const styles = {
    mainSection: {
      padding: isMobile ? '20px 0' : '40px 0',
      backgroundColor: '#f8fafc',
    },
    container: {
      maxWidth: isMobile ? '90%' : '1200px',
      margin: '0 auto',
      padding: '0 20px',
    },
    sectionHeading: {
      textAlign: 'center',
      marginBottom: isMobile ? '30px' : '60px',
    },
    sectionTitle: {
      fontSize: isMobile ? '1.5rem' : '2.5rem',
      fontWeight: '700',
      color: '#1e293b',
      marginBottom: '15px',
      fontFamily: "'Montserrat', sans-serif",
      background: 'linear-gradient(45deg, #4f46e5, #ec4899)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      display: 'inline-block',
    },
    sectionSubtitle: {
      fontSize: isMobile ? '0.8rem' : '1.1rem',
      color: '#64748b',
      maxWidth: isMobile ? '90%' : '700px',
      margin: '0 auto',
      lineHeight: '1.6',
      fontFamily: "'Poppins', sans-serif",
      ...oneWordPerLine,
    },
    facilitiesGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: isMobile ? '15px' : '30px',
      marginTop: '20px',
    },
    facilityCard: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: isMobile ? '20px' : '40px 30px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
      transition: 'all 0.3s ease',
      textAlign: 'center',
    },
    facilityIcon: {
      fontSize: isMobile ? '2rem' : '3rem',
      marginBottom: '20px',
      color: '#4f46e5',
      background: 'linear-gradient(45deg, #e0e7ff, #fae8ff)',
      width: isMobile ? '60px' : '80px',
      height: isMobile ? '60px' : '80px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 25px',
    },
    facilityTitle: {
      fontSize: isMobile ? '1.2rem' : '1.5rem',
      fontWeight: '600',
      marginBottom: '15px',
      color: '#1e293b',
      fontFamily: "'Poppins', sans-serif",
    },
    facilityDescription: {
      fontSize: isMobile ? '0.9rem' : '1rem',
      color: '#64748b',
      lineHeight: '1.6',
      fontFamily: "'Poppins', sans-serif",
      ...oneWordPerLine,
    },
  };

  return (
    <>
      <Navbar />
      <section style={styles.mainSection}>
        <div style={styles.container}>
          <div style={styles.sectionHeading}>
            <h2 style={styles.sectionTitle}>Our Facilities</h2>
            <p style={styles.sectionSubtitle}></p>
          </div>
          <div style={styles.facilitiesGrid}>
            {facilities.map((facility, index) => (
              <div key={index} style={styles.facilityCard}>
                <div style={styles.facilityIcon}>{facility.icon}</div>
                <h3 style={styles.facilityTitle}>{facility.title}</h3>
                {facility.description && <p style={styles.facilityDescription}>{facility.description}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
      <style>
        {`
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes gradientShift {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          div[style*='box-shadow']:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 25px -5px rgba(0, 0, 0, 0.2);
          }
          @media (min-width: 769px) {
            .facilities-grid {
              grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            }
          }
        `}
      </style>
    </>
  );
}

export default Facilities;